import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  GetCookie,
  toast,
  Switch,
} from "../../Libraries/Post/GetAllPostRelatedToScreen/AllPosts/index";

import {
  IconButton,
  TextField,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import plusIcon from "../../Assets/svgs/primary-shape.svg";


import {
  useAddMainLogoMutation,
  useGetMainLogoMutation,
  useDeleteMainLogoMutation,
  useUpdateScreenConfigsMutation,
  useGetScreenConfigsMutation,
} from "../../Redux/service/AllEmpData";

import "react-toastify/dist/ReactToastify.css";

export default function LogoContent({ currentScreen }) {

  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);

  // SWITCH STATE
  const [showLogoSettings, setShowLogoSettings] = useState(false);

  // COLOR STATE
  const [logoBgColor, setLogoBgColor] = useState("#ffffff");

  const [addMainLogo] = useAddMainLogoMutation();
  const [getMainLogo] = useGetMainLogoMutation();
  const [deleteMainLogo] = useDeleteMainLogoMutation();
  const [updateScreenConfigs] = useUpdateScreenConfigsMutation();
  const [getConfigsData] = useGetScreenConfigsMutation();

  useEffect(() => {
    const fetchExistingLogo = async () => {

      try {
        const formData = new FormData();

        formData.append(
          "txt_customer_id",
          localStorage.getItem("txt_customer_id")
        );

        formData.append(
          "security_token",
          await GetCookie("es_token")
        );

        const res = await getMainLogo(formData).unwrap();

        if (res?.status === "true") {

          if (res?.logo_main) {
            // setLogoPreview(res.logo_main);
             setLogoPreview(
                `${res?.logo_main}?t=${new Date().getTime()}`
              );
          }
          formData.append("ser_screen_id", currentScreen.ser_screen_id);
          const result = await getConfigsData(formData).unwrap();
          if (result?.data?.footer?.logo_configs?.background) {
            setLogoBgColor(
              result?.data?.footer?.logo_configs?.background
            );
          }
        }

      } catch (error) {
        console.error(error);
        toast.error(error?.status || "Failed to load logo");
      }
    };

    fetchExistingLogo();

  }, [currentScreen]);

  // LOGO CHANGE
  const handleLogoChange = (event) => {

    const file = event.target.files[0];

    if (!file) return;

    setLogoFile(file);
    setLogoPreview(URL.createObjectURL(file));
  };

  // REMOVE LOGO
  const handleRemoveLogo = async () => {

    try {

      const formData = new FormData();

      formData.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );

      formData.append(
        "security_token",
        await GetCookie("es_token")
      );

      const response = await deleteMainLogo(formData).unwrap();

      if (response?.status === "true") {

        toast.success("Logo removed successfully!");

        setLogoFile(null);
        setLogoPreview(null);

      } else {

        toast.error(response?.message || "Failed to remove logo");
      }

    } catch (error) {

      console.error(error);
      toast.error(error?.status || "Something went wrong");
    }
  };

  // SAVE LOGO
  const handleSaveLogo = async () => {

    if (!logoFile) return;

    try {

      const formData = new FormData();

      formData.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );

      formData.append(
        "security_token",
        await GetCookie("es_token")
      );

      formData.append("logoFile", logoFile);

      const response = await addMainLogo(formData).unwrap();

      if (response?.status === "true") {

        toast.success("Logo uploaded successfully!");

        if (response?.file_url) {
          setLogoPreview(response.file_url);
        }

        setLogoFile(null);

      } else {

        toast.error(response?.message || "Upload failed");
      }

    } catch (error) {

      console.error(error);
      toast.error(error?.status || "Upload error");
    }
  };

  // SAVE CONFIG COLOR
  const handleSaveBgColor = async () => {

    try {

      const formData = new FormData();

      formData.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );

      formData.append(
        "security_token",
        await GetCookie("es_token")
      );

      formData.append(
        "ser_screen_id",
        currentScreen?.ser_screen_id
      );

      formData.append(
        "configuration",
        JSON.stringify({
          footer: {
            logo_configs: {
              background: logoBgColor,
            },
          },
        })
      );

      const response = await updateScreenConfigs(formData).unwrap();

      if (response?.status === "true") {

        toast.success("Background color updated!");

      } else {

        toast.error("Failed to update color");
      }

    } catch (error) {

      console.error(error);
      toast.error(error?.status || "Update failed");
    }
  };

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Grid
          container
          className="bg bg-white py-4 px-4 pb-5"
          sx={{ borderRadius: "16px" }}
        >

          {/* HEADER */}
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <h5 style={{ color: "grey" }}>
              <b>Logo Settings</b>
            </h5>

            {/* SWITCH */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6
              }}
            >
              <span
                style={{
                  fontSize: "13px",
                  color: "#666"
                }}
              >
                Settings
              </span>

              <Switch
                size="small"
                checked={showLogoSettings}
                onChange={(e) =>
                  setShowLogoSettings(e.target.checked)
                }
              />
            </div>
          </Box>

          {/* LOGO SECTION */}
          <Grid item xs={12} sx={{ mt: 3 }}>

            {!logoPreview ? (

              <Button 
              startIcon={
                  <img
                    src={plusIcon}
                    alt="plus"
                    className="plus-icon"
                    style={{
                      width: "18px",
                      height: "18px",
                      objectFit: "contain",
                      transition: "0.3s ease",
                    }}
                  />
                }
              sx={{
                    maxHeight: "48px",
                    height: "40px",
                    width: "200px",
                    fontWeight: "bold",
                    textTransform: "none",
                    borderRadius: "8px",
                    background: "#1A75E829",
                    boxShadow: "none",
                    color: "#1A75E8",
                    fontSize: "15px",
                    transition: "0.3s ease",

                    "&:hover": {
                      backgroundColor: "#1A75E8",
                      color: "#ffffff",
                      boxShadow: "none",
                    },

                    "&:hover .plus-icon": {
                      filter: "brightness(0) invert(1)",
                    },
                  }}
              variant="contained" 
              component="label"
              >
                Add Main Logo

                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={handleLogoChange}
                />
              </Button>

            ) : (

              <Box
                sx={{
                  position: "relative",
                  display: "inline-block",
                  padding: "10px",
                  borderRadius: "10px",
                  backgroundColor: logoBgColor,
                }}
              >
                <img
                  src={logoPreview}
                  alt="Logo Preview"
                  style={{
                    width: "150px",
                    height: "auto",
                    borderRadius: "8px",
                  }}
                />

                <IconButton
                  onClick={handleRemoveLogo}
                  sx={{
                    position: "absolute",
                    top: -10,
                    right: -10,
                    backgroundColor: "#fff",
                    boxShadow: 2,
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            )}
          </Grid>

          {/* SAVE LOGO BUTTON */}
          {logoFile && (
            <Grid item xs={12} sx={{ mt: 3 }}>
              <Button
                variant="contained"
                onClick={handleSaveLogo}
              >
                Save Logo
              </Button>
            </Grid>
          )}

        </Grid>
      </Box>

      {/* SETTINGS DIV */}
      {showLogoSettings && (

        <Box sx={{ mt: 2 }}>

          <Grid
            container
            className="bg bg-white py-4 px-4"
            sx={{ borderRadius: "16px" }}
          >

            <Grid item xs={12}>
              <h6
                style={{
                  fontWeight: 600,
                  color: "#7e7e7e"
                }}
              >
                Logo Background Color
              </h6>
            </Grid>

            {/* COLOR PICKER */}
            <Grid item xs={12} sm={6} sx={{ mt: 2 }}>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2
                }}
              >

                <input
                  type="color"
                  value={logoBgColor}
                  onChange={(e) =>
                    setLogoBgColor(e.target.value)
                  }
                  style={{
                    width: "35px",
                    height: "35px",
                    border: "none",
                    cursor: "pointer",
                    background: "none",
                  }}
                />

                <TextField
                  fullWidth
                  size="small"
                  value={logoBgColor}
                  onChange={(e) =>
                    setLogoBgColor(e.target.value)
                  }
                />
              </Box>
            </Grid>

            {/* SAVE CONFIG BUTTON */}
            <Grid item xs={12} sx={{ mt: 3 }}>

              <Button
                variant="contained"
                onClick={handleSaveBgColor}
              >
                Save
              </Button>

            </Grid>

          </Grid>

        </Box>
      )}
    </>
  );
}